import React, { ForwardedRef, ReactNode } from 'react';
import classNames from 'classnames';
import { Button, Dropdown } from 'react-bootstrap';

import { ReactComponent as ChevronUpIcon } from '../../shared/icons/chevron-up.svg';
import { ReactComponent as ChevronDownIcon } from '../../shared/icons/chevron-down.svg';

import styles from './styles.module.scss';

export { Dropdown };

export const DropdownBody = ({
  children,
  as: Component = 'div',
}: {
  children: ReactNode;
  as?: keyof JSX.IntrinsicElements;
}) => {
  return <Component className={styles.dropdownBody}>{children}</Component>;
};

export const DropdownItem = ({
  children,
  highlightable = false,
  as: Component = 'div',
  className,
  onClick,
  ...rest
}: {
  children: ReactNode;
  highlightable?: boolean;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  onClick?: () => void;
  [key: string]: any;
}) => (
  <Component
    className={classNames(styles.dropdownItem, { [styles.highlightable]: highlightable }, className)}
    onClick={onClick}
    {...rest}
  >
    {children}
  </Component>
);

export const DropdownToggle = React.forwardRef(
  (
    {
      children,
      className,
      contentClassName,
      ...rest
    }: { children: ReactNode; className?: string; contentClassName?: string; 'aria-expanded'?: boolean },
    ref: ForwardedRef<any>
  ) => (
    <Button
      ref={ref}
      className={classNames(className, styles.dropdownToggle, 'd-flex align-items-center')}
      {...rest}
      variant=""
    >
      <span className={contentClassName}>{children}</span>
      <span className="ml-2 text-primary">{rest['aria-expanded'] ? <ChevronUpIcon /> : <ChevronDownIcon />}</span>
    </Button>
  )
);

export const DropdownTogglePeople = React.forwardRef(
  (
    {
      children,
      className,
      contentClassName,
      ...rest
    }: { children: ReactNode; className?: string; contentClassName?: string; 'aria-expanded'?: boolean },
    ref: ForwardedRef<any>
  ) => (
    <Button
      ref={ref}
      className={classNames(className, styles.dropdownTogglePeople, 'd-flex align-items-center')}
      {...rest}
      variant=""
    >
      <span className={contentClassName}>{children}</span>
      <span className="ml-2 text-primary">{rest['aria-expanded'] ? <ChevronUpIcon /> : <ChevronDownIcon />}</span>
    </Button>
  )
);

export const DropdownToggleOrange = React.forwardRef(
  (
    {
      children,
      className,
      contentClassName,
      ...rest
    }: { children: ReactNode; className?: string; contentClassName?: string; 'aria-expanded'?: boolean },
    ref: ForwardedRef<any>
  ) => (
    <Button ref={ref} className={classNames('d-flex justify-content-between align-items-center', className)} {...rest}>
      <span className={contentClassName}>{children}</span>
      <span className="ml-2 text-white">{rest['aria-expanded'] ? <ChevronUpIcon /> : <ChevronDownIcon />}</span>
    </Button>
  )
);

export const DropdownToggleBlue = React.forwardRef(
  (
    {
      children,
      className,
      contentClassName,
      ...rest
    }: { children: ReactNode; className?: string; contentClassName?: string; 'aria-expanded'?: boolean },
    ref: ForwardedRef<any>
  ) => (
    <Button ref={ref} className={classNames(className, 'd-flex justify-content-between align-items-center')} {...rest}>
      <span className={contentClassName}>{children}</span>
      <span className="ml-2 text-white">{rest['aria-expanded'] ? <ChevronUpIcon /> : <ChevronDownIcon />}</span>
    </Button>
  )
);

export const DropdownToggleIcon = React.forwardRef(
  (
    {
      children,
      className,
      contentClassName,
      ...rest
    }: { children: ReactNode; className?: string; contentClassName?: string; 'aria-expanded'?: boolean },
    ref: ForwardedRef<any>
  ) => (
    <Button ref={ref} className={classNames(className, 'd-flex justify-content-between align-items-center')} {...rest}>
      <span className={contentClassName}>{children}</span>
      <span className="text-primary">{rest['aria-expanded'] ? <ChevronUpIcon /> : <ChevronDownIcon />}</span>
    </Button>
  )
);
